import ToolMark from './ToolMark';
import FontFamilyPicker from '../FontFamilyPlugin/components/FontFamilyPicker';

// Toggles a font family mark on the currently selected elements
class ToolFontFamily extends ToolMark {
  static toolName = 'Font';
  static iconClass = 'fa-regular fa-text';
  static mark = 'fontFamily' as const;

  static toolbarSubmenu() {
    return FontFamilyPicker;
  }
}

export default ToolFontFamily;
